import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { ScrewFamily } from "../../../../http/deckDesigner/types/screwFamilies";
import useDeckScrewFamiliesApi from "../../../../http/deckDesigner/useScrewFamilies";
import ScrewFamilyForm from "./ScrewFamilyForm";

const AdminScrewFamilies: FC = () => {
  const i18n = useI18n();
  const screwFamiliesApi = useDeckScrewFamiliesApi();

  return (
    <AdminCrudTable<ScrewFamily>
      filterPrefix="screw_families"
      useList={screwFamiliesApi.useDeckScrewFamilies}
      head={
        <>
          <TableHeadCell align="left">{i18n.translation.common.name}</TableHeadCell>
          <TableHeadCell align="left">
            {i18n.translation.deckDesignerModule.substructureMaterials.singular}
          </TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{item.name}</TableCell>
          <TableCell>{item.substructureMaterials.map((m) => m.name).join(", ")}</TableCell>
        </>
      )}
      visibilityAndOrder={{
        updateVisibility: (item, visibility) =>
          screwFamiliesApi.updateDeckScrewFamilyVisibility(item.id, { visibility }),
        updateOrder: (item, order) => screwFamiliesApi.updateDeckScrewFamilyOrder(item.id, { order }),
      }}
      onDelete={(item) => screwFamiliesApi.deleteDeckScrewFamily(item.id)}
      deleteTitle={i18n.translation.deckDesignerModule.screwFamilies.singular}
      canAdd
      renderForm={(item, onClose) => <ScrewFamilyForm screwFamily={item} onClose={onClose} />}
    />
  );
};

export default AdminScrewFamilies;
